import { AxiosRequestConfig } from 'axios';
import { Autocomplete, AutocompleteProps } from '@mui/material';

import { Document } from '@/types';
import { useGetDocumentsQuery } from '@/services';
import { useAsyncSearch } from '@/hooks';

function SearchDocuments<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>({
  config,
  value,
  ...props
}: { config?: AxiosRequestConfig<Document> } & Omit<
  AutocompleteProps<Document, Multiple, DisableClearable, FreeSolo>,
  'options'
>) {
  const asyncGetDocumentsQueryProps = useAsyncSearch<Document, Multiple, DisableClearable, FreeSolo>(
    useGetDocumentsQuery,
    'id',
    value,
    config,
  );

  return <Autocomplete {...props} {...asyncGetDocumentsQueryProps} />;
}

export default SearchDocuments;
